import {
  Button,
  Inline,
  Link,
  Modal,
  type ModalProps,
  Typography,
} from '@omnipresentgroup/design-system';
import { useXeroConnectionDeletionMutation } from '@omnipresentgroup/domains';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { INTEGRATIONS_PATH } from '../../constants';
import { XERO_FAQ_LINK } from './constants';

type XeroDisconnectModalModalProps = {
  modalProps: Omit<ModalProps, 'children'>;
  handleClose: () => void;
  clientId: string;
};

export const MODAL_TITLE = 'Are you sure you want to disconnect Xero?';
export const MODAL_DESCRIPTION =
  'If you disconnect Xero, you will no longer automatically receive Omnipresent invoices within your Xero account. However we will continue sending invoices via email.';

export const XeroDisconnectModal = (props: XeroDisconnectModalModalProps) => {
  const navigate = useNavigate();

  const { modalProps, clientId, handleClose } = props;

  const {
    mutate: deleteXeroIntegration,
    isPending,
    isSuccess,
  } = useXeroConnectionDeletionMutation({
    clientId,
    onSuccess: () => navigate(INTEGRATIONS_PATH),
  });

  useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess, handleClose]);

  return (
    <Modal {...modalProps} span={5}>
      <Modal.Header title={MODAL_TITLE} />

      <Modal.Body>
        <Typography as="span" size="16">
          {MODAL_DESCRIPTION}
        </Typography>
      </Modal.Body>

      <Modal.Footer>
        <Link
          size="16"
          icon="ExternalLink"
          onClick={() => {
            window.open(XERO_FAQ_LINK, '_blank', 'noopener,noreferrer');
          }}
        >
          View FAQs
        </Link>
        <Inline>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => deleteXeroIntegration()}
            loading={isPending}
          >
            Yes
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
